export const CURRENT_USER_NAME = "currentUsername";
export const CURRENT_USER_ID = "currentUserId";
export const SHOW_WELCOME_BANNER = "showWelcomeBanner";
export const STAY_LOGGED_IN = "stayLoggedIn";
export const SESSION_BANNER = "sessionBanner";
export const TRANSACTION = "TRANSACTION";
export const CUSTOMER_NAME = "customerName";
export const IS_NOTIFICATION_SYNCED = "isNotificationSynced";
